import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';

type Channel = {
    id: string; name: string; isPublic: boolean;
    allowMessages: boolean; allowImages: boolean; enableMeeting: boolean;
    members: number; messages: number;
};

export default function AdminChannels() {
    const [channels, setChannels] = useState<Channel[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { load(); }, []);

    async function load() {
        try { setChannels(await (await api.adminChannelsApi.list()).json()); }
        catch (x: any) { api.adminError(x); }
        finally { setLoaded(true); }
    }

    async function create() {
        if (!name.trim()) return;
        try {
            const r = await (await api.adminChannelsApi.create({
                name: name.trim(), description: "", isPublic: true,
                allowMessages: true, allowImages: true, enableMeeting: false,
            })).json();
            setName("");
            navigate("/admin/komunita/" + r.id);
        } catch (x: any) { api.adminError(x); }
    }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Komunita</h1><p>Diskuzní kanály, viditelnost a schůzky</p></div>
            </div>

            <div className="searchBar" style={{ maxWidth: "460px" }}>
                <input placeholder="Název nového kanálu…" value={name} onChange={e => setName(e.target.value)} onKeyDown={e => e.key === "Enter" && create()} />
                <button className="aBtn" disabled={!name.trim()} onClick={create}>+ Vytvořit</button>
            </div>

            <table className="aTable">
                <thead><tr><th>Kanál</th><th>Viditelnost</th><th>Zprávy</th><th>Obrázky</th><th>Schůzka</th><th>Členů</th><th>Zpráv</th></tr></thead>
                <tbody>
                    {channels.map(c => (
                        <tr key={c.id} onClick={() => navigate("/admin/komunita/" + c.id)}>
                            <td>{c.name || <span className="muted">(bez názvu)</span>}</td>
                            <td>{c.isPublic ? "Veřejný" : "Jen členové"}</td>
                            <td>{c.allowMessages ? "✓" : "—"}</td>
                            <td>{c.allowImages ? "✓" : "—"}</td>
                            <td>{c.enableMeeting ? "✓" : "—"}</td>
                            <td>{c.isPublic ? <span className="muted">vše</span> : c.members}</td>
                            <td>{c.messages}</td>
                        </tr>
                    ))}
                    {loaded && channels.length === 0 && <tr><td colSpan={7} className="muted">Žádné kanály.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}
